import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'react-bootstrap';
import toast from 'react-hot-toast';
import AlertModal from 'components/common-components/AlertModal';
import FormButton from 'components/form-components/FormButton';
import FormLoadingButton from 'components/form-components/FormLoadingButton';
import TextField from 'components/form-components/TextField';
import { CallAPI } from 'actions/General';
import { useTranslation } from 'react-i18next';

const AddOptionsSetsModal = ({ show, editId, onCancel, refreshList }) => {
  const { t } = useTranslation();
  const [saveLoading, setSaveLoading] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [values, setValues] = useState({ title: '' });
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  const handleChange = (field, value) => {
    setTouched({ ...touched, [field]: true });
    setErrors({ ...errors, [field]: undefined });
    setValues({ ...values, [field]: value });
  };

  const handleSubmit = async () => {
    const payload = { title: values.title };
    const apiType = editId ? 'UPDATE_TOPICS_SET' : 'ADD_TOPICS_SET';
    const successMsg = editId ? 'alert_success_topic_set_updated' : 'alert_success_topic_set_added';

    const result = await CallAPI(apiType, payload, editId, setSaveLoading);
    if (result?.status) {
      toast.success(t(successMsg));
      refreshList();
      onCancel();
    } else {
      toast.error(result.error);
    }
  };

  const fetchTopicSetDetail = async () => {
    const result = await CallAPI(`GET_TOPICS_SET_DETAIL`, null, editId, setFetchLoading);
    if (result.status) {
      setValues({
        title: result.data.title,
      });
    }
  };

  useEffect(() => {
    if (editId) fetchTopicSetDetail();
  }, [editId]);

  return (
    <div>
      <AlertModal show={show} actionButtons={[]} noPadding>
        <div className='w-100'>
          <label className='w-100 px-4 py-3 border-bottom-grey-1-h-1 theme-size-1_3 text-black fw-medium'>
            {t('text_add_topic')}
          </label>

          {fetchLoading ? (
            <div className='text-center my-3'>
              <Spinner className='theme-text-green-1' />
            </div>
          ) : (
            <div className='px-4 py-3 mb-5'>
              <TextField
                value={values.title}
                name='title'
                classes='w-auto'
                handleChange={handleChange}
                placeholder='field_name'
                displayName='field_name'
                shrinkFieldOnly
              />
            </div>
          )}

          <div className='d-flex gap-2 justify-content-end p-3 border-top-grey-1-h-1'>
            <FormButton text={'button_cancel'} variant='white-1' onClick={onCancel} />
            <FormLoadingButton
              text={editId ? 'button_update' : 'button_create'}
              variant='green-1'
              loading={saveLoading}
              disabled={values.title.trim() === ''}
              onClick={handleSubmit}
            />
          </div>
        </div>
      </AlertModal>
    </div>
  );
};

AddOptionsSetsModal.propTypes = {
  show: PropTypes.bool.isRequired,
  editId: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  refreshList: PropTypes.func.isRequired,
};

export default AddOptionsSetsModal;
